import { useQuery } from 'data-fetching-client';
import { GET_OBJECT_TYPE_PROPERTIES } from 'flow-doctor-lib/queries/CrmObjectQueries';
const buildObjectTypePropertyMap = properties => {
  return properties.reduce((acc, propWrapper) => {
    acc[propWrapper.property.name] = {
      objectTypeId: propWrapper.objectTypeId,
      property: Object.assign({}, propWrapper.property, {
        referenceType: propWrapper.property.externalOptionsReferenceType || propWrapper.property.referencedObjectType
      })
    };
    return acc;
  }, {});
};
const useObjectTypeProperties = ({
  portalId,
  objectTypeId
}, {
  skip
} = {}) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_OBJECT_TYPE_PROPERTIES, {
    variables: {
      portalId,
      objectTypeId
    },
    skip
  });
  const dataToReturn = data ? buildObjectTypePropertyMap(data.objectProperties) : null;
  return {
    data: dataToReturn,
    loading,
    error
  };
};
export default useObjectTypeProperties;